export default {
    mode: 'history',
	routes: [
        // 确保 path '/' 的位置在首位.
        {
			path: '/',
            name: 'index',
            zh_name: '主页面',
            redirect: {name: "login"},
            component: () => import('@/views/index.vue'),
            children: [
                {
                    path:'admin',
                    name:'admin',
                    component:()=>import('@/views/admin/admin.vue'),
                    redirect: {name: "admin-pend-warning"},
                    children:[
                        {
                            path: 'pend-warning',
                            name: 'admin-pend-warning',
                            meta: { title: '待处理告警', back: false, },
                            component: () => import('@/views/admin/pend-warning/pendWarning.vue'),   
                        },
                        {
                            path: 'site-managing',
                            name: 'admin-site-managing',
                            meta: { title: '站点管理', back: false, },
                            component: () => import('@/views/admin/site-managing/siteManaging.vue'),   
                        },
                        {
                            path: 'person-managing',
                            name: 'admin-person-managing',
                            meta: { title: '人员管理', back: false, },
                            component: () => import('@/views/admin/person-managing/personManaging.vue'),   
                        },
                        {
                            path: 'server-authorization',
                            name: 'admin-server-authorization',
                            meta: { title: '服务授权', back: false, },
                            component: () => import('@/views/admin/server-authorization/serverAuthorization.vue'),   
                        },
                        {
                            path: 'notice-rule',
                            name: 'admin-notice-rule',
                            meta: { title: '通知规则', back: false, },
                            component: () => import('@/views/admin/notice-rule/noticeRule.vue'),   
                        },  
                        {
                            path: 'workList-managing',
                            name: 'admin-workList-managing',
                            meta: { title: '工单管理', back: false, },
                            component: () => import('@/views/admin/workList-managing/worklistManaging.vue'),   
                            children:[
                                {
                                    path:'process-workList',
                                    name:'admin-process-workList',
                                    meta: { title: '处理中工单', back: false, },
                                    component: () => import('@/views/admin/workList-managing/processWorkList.vue')
                                },
                                {
                                    path:'dealing-workList',
                                    name:'admin-dealing-workList',
                                    meta: { title: '待指派工单', back: false, },
                                    component: () => import('@/views/admin/workList-managing/dealingWorkList.vue')
                                },
                                {
                                    path:'close-workList',
                                    name:'admin-close-workList',
                                    meta: { title: '已关闭工单', back: false, },
                                    component: () => import('@/views/admin/workList-managing/closeWorkList.vue')
                                },
                                {
                                    path:'assign-workList/:id',
                                    name:'admin-assign-workList',
                                    meta: { title: '指派工单', back: true, },
                                    component: () => import('@/views/admin/workList-managing/assignWorkList.vue')
                                },
                                {
                                    path:'edit-workList/:id/:sort',
                                    name:'admin-edit-workList',
                                    meta: { title: '指派工单', back: true, },
                                    component: () => import('@/views/admin/workList-managing/editWorkList.vue')
                                },
                            ]
                        },

                    ]
                },
                {
                    path:'user',
                    name:'user',
                    component:()=>import('@/views/user/user.vue'),
                    redirect: {name: "user-pend-warning"},
                    children:[
                        {
                            path: 'pend-warning',
                            name: 'user-pend-warning',
                            meta: { title: '待处理告警', back: false, },
                            component: () => import('@/views/user/pend-warning/pendWarning.vue'),   
                        }, 
                        {
                            path: 'warning-list',
                            name: 'user-warning-list',
                            meta: { title: '告警列表', back: false, },
                            component: () => import('@/views/user/warning-list/warningList.vue'),   
                        }, 
                        {
                            path: 'notice-rule',
                            name: 'user-notice-rule',
                            meta: { title: '通知列表', back: false, },
                            component: () => import('@/views/user/notice-rule/noticeRule.vue'),   
                        },
                        {
                            path: 'notice-list',
                            name: 'user-notice-list',
                            meta: { title: '通知规则', back: false, },
                            component: () => import('@/views/user/notice-list/noticeList.vue'),   
                        },
                        {
                            path: 'workList-managing',
                            name: 'user-workList-managing',
                            meta: { title: '工单管理', back: false, },
                            component: () => import('@/views/user/workList-managing/worklistManaging.vue'), 
                            children:[
                                {
                                    path:'process-workList',
                                    name:'user-process-workList',
                                    meta: { title: '处理中工单', back: false, },
                                    component: () => import('@/views/user/workList-managing/processWorkList.vue')
                                },
                                {
                                    path:'close-workList',
                                    name:'user-close-workList',
                                    meta: { title: '已关闭工单', back: false, },
                                    component: () => import('@/views/user/workList-managing/closeWorkList.vue')
                                },
                                {
                                    path:'new-workList',
                                    name:'user-new-workList',
                                    meta: { title: '新建工单', back: false, },
                                    component: () => import('@/views/user/workList-managing/newWorkList.vue')
                                },
                                {
                                    path:'edit-workList/:id/:sort',
                                    name:'user-edit-workList',
                                    meta: { title: '工单详情', back: true, },
                                    component: () => import('@/views/user/workList-managing/editWorkList.vue')
                                },
                            ]  
                        },
                        {
                            path: 'data-intellige',
                            name: 'user-data-intellige',
                            meta: { title: '数据智能', back: false, },
                            component: () => import('@/views/user/data-intellige/dataIntellige.vue'), 
                            children:[
                                {
                                    path:'comprehensive-inspection',
                                    name:'user-comprehensive-inspection',
                                    meta: { title: '巡检报告', back: false, },
                                    component: () => import('@/views/user/data-intellige/comprehensiveInspection.vue')
                                },
                                {
                                    path:'inspection-report/:report_id',
                                    name:'user-inspection-report',
                                    meta: { title: '巡检报告', back: true, },
                                    component: () => import('@/views/user/data-intellige/inspectionReport.vue')
                                },
                                {
                                    path:'awr-unscramble',
                                    name:'user-awr-unscramble',
                                    meta: { title: 'AWR报告解读', back: false, },
                                    component: () => import('@/views/user/data-intellige/awrUnscramble.vue')
                                },
                                {
                                    path:'html-report/:history_id',
                                    name:'user-html-report',
                                    meta: { title: 'AWR报告', back: true, },
                                    component: () => import('@/views/user/data-intellige/htmlReport.vue')
                                },
                                {
                                    path:'markdown-report/:history_id',
                                    name:'user-markdown-report',
                                    meta: { title: 'AWR报告解读', back: true, },
                                    component: () => import('@/views/user/data-intellige/markdownReport.vue')
                                },
                            ] 
                        },
                    ]
                },
                {
                    path:'surperAdmin',
                    name:'surperAdmin',
                    component:()=>import('@/views/oneKeeper/oneKeeper.vue'),
                    redirect: {name: "parnter"},
                    children:[
                        {
                            path:'partner-count',
                            name:'partner-count',
                            meta: { title: '数据总览', back: false, },
                            component: () => import('@/views/oneKeeper/partnerCount/partnerCount.vue')
                        },
                        {
                            path:'parnter',
                            name:'parnter',
                            meta: { title: '合作伙伴', back: false, },
                            component: () => import('@/views/oneKeeper/partner/partner.vue')
                        },
                    ]
                },
                {
                    path:'demo',
                    name:'demo',
                    component:()=>import('@/views/demo/demo.vue'),
                    children:[]
                }
            ],
        },
        {
            path:'/download-tool',
            name:'user-download-tool',
            meta: { title: '下载', back: true, },
            component: () => import('@/views/user/data-intellige/downloadTool.vue')
        },
        {
            path: '/login',
            name: 'login',
            zh_name: '登陆',
            component: () => import('@/views/login.vue'),
        },
        {
            path: '/onekeeper',
            name: 'onekeeper',
            zh_name: '登陆',
            component: () => import('@/views/oneKeeperLogin.vue')
        },
        {
            path: '/big-screen-map',
            name: 'big-screen-map',
            zh_name: '大屏',
            component: () => import('@/views/bigScreenMap.vue'),   
        },   
	]
}